import { defineComponent, getCurrentInstance, inject, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, withCtx, createBlock, renderSlot, createTextVNode, toDisplayString, createCommentVNode, Transition, mergeProps } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { collapseKey } from "./context.js";
import AIconHover from "../_components/icon-hover.js";
import IconCaretRight from "../icon/icon-caret-right/index.js";
import IconCaretLeft from "../icon/icon-caret-left/index.js";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "CollapseItem",
  components: { IconHover: AIconHover, IconCaretRight, IconCaretLeft },
  props: {
    key: String,
    header: String,
    disabled: {
      type: Boolean,
      default: false
    },
    showExpandIcon: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    var _a;
    const prefixCls = getPrefixCls("collapse-item");
    const component = getCurrentInstance();
    const collapseCtx = inject(collapseKey, void 0);
    const key = String((_a = component == null ? void 0 : component.vnode.key) != null ? _a : "");
    const isActive = computed(() => collapseCtx == null ? void 0 : collapseCtx.activeKeys.includes(key));
    const expandIconPosition = computed(() => {
      var _a2;
      return (_a2 = collapseCtx == null ? void 0 : collapseCtx.expandIconPosition) != null ? _a2 : "left";
    });
    const handleClick = (e) => {
      if (!props.disabled) {
        collapseCtx == null ? void 0 : collapseCtx.handleClick(key, e);
      }
    };
    const transitionEvents = {
      onAppear: (el) => {
        el.style.height = "auto";
      },
      onBeforeEnter: (el) => {
        el.style.display = "block";
      },
      onEnter: (el) => {
        el.style.height = `${el.scrollHeight}px`;
      },
      onAfterEnter: (el) => {
        el.style.height = "auto";
      },
      onBeforeLeave: (el) => {
        el.style.display = "block";
        el.style.height = `${el.scrollHeight}px`;
      },
      onLeave: (el) => {
        el.style.height = "0";
      },
      onAfterLeave: (el) => {
        el.style.display = "none";
      }
    };
    const cls = computed(() => [
      prefixCls,
      {
        [`${prefixCls}-active`]: isActive.value
      }
    ]);
    const headerCls = computed(() => [
      `${prefixCls}-header`,
      `${prefixCls}-header-${collapseCtx == null ? void 0 : collapseCtx.expandIconPosition}`,
      {
        [`${prefixCls}-header-disabled`]: props.disabled
      }
    ]);
    const iconCls = computed(() => [
      {
        [`${prefixCls}-icon-right`]: (collapseCtx == null ? void 0 : collapseCtx.expandIconPosition) === "right"
      }
    ]);
    const contentCls = computed(() => [
      `${prefixCls}-content`,
      {
        [`${prefixCls}-content-expend`]: isActive.value
      }
    ]);
    return {
      prefixCls,
      cls,
      headerCls,
      iconCls,
      contentCls,
      isActive,
      expandIconPosition,
      transitionEvents,
      handleClick
    };
  },
  render: void 0
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_caret_left = resolveComponent("icon-caret-left");
  const _component_icon_caret_right = resolveComponent("icon-caret-right");
  const _component_icon_hover = resolveComponent("icon-hover");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.cls)
  }, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.headerCls),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClick && _ctx.handleClick(...args))
    }, [
      createVNode(_component_icon_hover, {
        prefix: _ctx.prefixCls,
        class: normalizeClass(_ctx.iconCls),
        disabled: _ctx.disabled
      }, {
        default: withCtx(() => [
          _ctx.expandIconPosition === "right" ? (openBlock(), createBlock(_component_icon_caret_left, {
            key: 0,
            class: normalizeClass(`${_ctx.prefixCls}-expand-icon`)
          }, null, 8, ["class"])) : (openBlock(), createBlock(_component_icon_caret_right, {
            key: 1,
            class: normalizeClass(`${_ctx.prefixCls}-expand-icon`)
          }, null, 8, ["class"]))
        ]),
        _: 1
      }, 8, ["prefix", "class", "disabled"]),
      createElementVNode("div", {
        class: normalizeClass(`${_ctx.prefixCls}-header-title`)
      }, [
        renderSlot(_ctx.$slots, "header", {}, () => [
          createTextVNode(toDisplayString(_ctx.header), 1)
        ])
      ], 2),
      _ctx.$slots.extra ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(`${_ctx.prefixCls}-header-extra`)
      }, [
        renderSlot(_ctx.$slots, "extra")
      ], 2)) : createCommentVNode("v-if", true)
    ], 2),
    createVNode(Transition, mergeProps({ name: "collapse-slider" }, _ctx.transitionEvents, { appear: "" }), {
      default: withCtx(() => [
        _ctx.isActive ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(_ctx.contentCls)
        }, [
          createElementVNode("div", {
            ref: "contentBoxRef",
            class: normalizeClass(`${_ctx.prefixCls}-content-box`)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ], 2)) : createCommentVNode("v-if", true)
      ]),
      _: 3
    }, 16)
  ], 2);
}
var _CollapseItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { _CollapseItem as default };
